<script setup lang="ts">
/**
 * Первое пространство базы знаний.
 *
 * Ключ сервис не сворачивает: строчные буквы он отвергает, а не переводит в
 * заглавные — ключ, который выглядит не так, как его набрали, потом печатают
 * с ошибкой вечно. Поэтому проверяем здесь же и подсказываем вид.
 */
import { AppButton, AppModal, AppTextField } from '@vinprop/design-system'
import { computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'

import { errorMessage } from '@/api/errors'

import { createSpace, SPACE_KEY } from '../api'

const emit = defineEmits<{ done: [string]; close: [] }>()

const { t } = useI18n()

const key = ref('')
const name = ref('')
const busy = ref(false)
const error = ref('')

const isValid = computed(() => SPACE_KEY.test(key.value.trim()) && name.value.trim().length > 0)

const submit = async () => {
  if (!isValid.value) return

  busy.value = true
  error.value = ''

  try {
    const space = await createSpace(key.value.trim(), name.value.trim())

    emit('done', space.id)
  } catch (failure) {
    error.value = errorMessage(failure, t('kb.newSpace.failed'))
  } finally {
    busy.value = false
  }
}
</script>

<template>
  <AppModal model-value :title="t('kb.newSpace.title')" size="small" @update:model-value="emit('close')">
    <div class="nspace">
      <AppTextField
        v-model="key"
        :label="t('kb.newSpace.key')"
        placeholder="ADR"
        :error="key && !SPACE_KEY.test(key.trim()) ? t('kb.newSpace.keyInvalid') : error"
      />
      <AppTextField v-model="name" :label="t('kb.newSpace.name')" placeholder="Архитектура" />
    </div>

    <template #footer>
      <AppButton variant="secondary" @click="emit('close')">
        {{ t('common.actions.cancel') }}
      </AppButton>
      <AppButton :loading="busy" :disabled="!isValid" @click="submit">
        {{ t('kb.newSpace.create') }}
      </AppButton>
    </template>
  </AppModal>
</template>

<style scoped>
.nspace {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
</style>
